<app-header [showHeaders]="showMenu" (onToggleMenu)="toggleMenu()"></app-header>
@if (showMenu) {
  <app-menu class="d-none d-lg-block"></app-menu>
}
@if (showMenu) {
  <app-menu-mobile [collapsed]="isMenuCollapsed" (onToggleMenu)="toggleMenu()" class="d-block d-lg-none"></app-menu-mobile>
}
<router-outlet></router-outlet>
<app-version></app-version>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
@if (loaderService.loading | async) {
  <app-progress-indicator></app-progress-indicator>
}
<app-questionnaire-parcours-travaux></app-questionnaire-parcours-travaux>
<app-parcours-travaux-call-to-action-modal></app-parcours-travaux-call-to-action-modal>
